import {
  IProductData,
  IPartnerProductSearchResultValue,
  IOrderRow,
  IProductCategory,
  IServiceproduct,
  IProductSearchResultValue,
} from "@iloq/shared";
import config from "@/config";

export function productToOrderRow(
  p: IProductData | IPartnerProductSearchResultValue,
  quantity = 1
): IOrderRow {
  return {
    quantity,
    product: {
      id: p.sku,
      name: `${p.product_name}${p.subtitle ? ` - ${p.subtitle}` : ""}`,
      categories: p.categories || [],
      imageUrl: p.main_image || undefined,
      price: {
        price: parseFloat(`${p.price}`),
        currencyCode: p.currencyCode,
      },
      partnerDiscountPrice:
        p.partnerDiscountPrice || p.partnerDiscountPrice === 0
          ? {
              price: parseFloat(`${p.partnerDiscountPrice}`),
              currencyCode: p.currencyCode,
            }
          : undefined,
      partnerDiscountPercentage: p.partnerDiscountPercentage,
      deliveryDelayInDays: p.delivery_delay_in_days,
      maxOrderQuantity: p.maximum_order_quantity,
      family: p.family,
      additional_note: p.additional_note,
      main_category: p.main_category,
      antimicrobial_coating: p.antimicrobial_coating,
    },
    availability: p.availability || "AVAILABLE",
    availabilityQty: p.availabilityQty || 0,
    rowTotalSum: 0,
  };
}

export function serviceproductToOrderRow(
  product: IServiceproduct,
  currencyCode: string
): IOrderRow {
  return {
    quantity: 1,
    quantityToShip: undefined,
    availability: "AVAILABLE",
    availabilityQty: 0,
    rowTotalSum: 0,
    product: {
      ...product,
      price: {
        price: product.price!.price,
        currencyCode,
      },
    },
    rowDiscountPercentage: undefined,
    promisedDeliveryDate: undefined,
  };
}

export function isBundledProduct(cartItem: IOrderRow, categoryTree: any) {
  let isBundledProduct = false;
  const bundledProductCategories = config.get("bundledProductCategories");
  cartItem.product.categories.forEach((category: string) => {
    Object.values(bundledProductCategories).forEach((bundleCategoryValue: any) => {
      if (isProductCategoryChildOf(category, bundleCategoryValue, categoryTree)) {
        isBundledProduct = true;
      }
    });
  });
  return isBundledProduct;
}

export function isProductCategoryChildOf(
  childCategoryId: string,
  parentCategoryId: string,
  categoryTree: IProductCategory
) {
  if (childCategoryId === parentCategoryId) {
    return true;
  }
  const findSubtreeStartingFrom = (
    tree: IProductCategory,
    id: string
  ): IProductCategory | undefined => {
    if (tree.id === id) {
      return tree;
    }
    if (tree.children) {
      let match: IProductCategory | undefined = undefined;
      tree.children.find((child) => {
        const result = findSubtreeStartingFrom(child, id);
        if (result) {
          match = result;
          return true;
        }
        return false;
      });
      return match;
    }
    return undefined;
  };
  const parent = findSubtreeStartingFrom(categoryTree, parentCategoryId);
  if (parent) {
    const child = findSubtreeStartingFrom(parent, childCategoryId);
    if (child) {
      return true;
    }
  }
  return false;
}

export function isQuantityOverProductSpecificMaxLimit(
  currentRows: IOrderRow[],
  quantityToAdd: number,
  product: IProductSearchResultValue | IProductData
) {
  if (!product.maximum_order_quantity) {
    return false;
  }
  const currentQuantity = currentRows.find((row) => row.product.id === product.sku)?.quantity || 0;
  return currentQuantity + quantityToAdd > product.maximum_order_quantity!;
}

export function isSurfaceTreatmentFeeRequired(rows: IOrderRow[]): boolean {
  return (
    rows.find((row) => {
      return row.product.main_category === "B" && row.product.antimicrobial_coating === true;
    }) !== undefined
  );
}
